import React from 'react';
import dayjs from 'dayjs';
import { CtoF } from 'utils/utils';

interface ForecastDayData {
  conditionCode: string;
  forecastStart: string;
  temperatureMax: number;
  temperatureMin: number;
}
interface ForecastData {
  data: ForecastDayData[];
}

const SevenDay = (sevenDay: ForecastData) => {
  return (
    <section className="weather-7day">
      <h2 className="type-sm type-caps">7 Day Forecast</h2>
      <ul className="weather-7day-list">
        {sevenDay &&
          sevenDay.data &&
          sevenDay.data.map((day, i) => {
            return (
              <li className="weather-7day-day" key={i}>
                <div className="weather-7day-dayname type-lg">
                  {dayjs(day.forecastStart).format('ddd')}
                </div>
                <div className="weather-7day-conditions">
                  <img
                    src={`/siteicons/weatherkitIcons/svg/${day.conditionCode.toLowerCase()}.svg`}
                    alt={day.conditionCode}
                  />
                </div>
                <div className="weather-7day-high type-xl">
                  {CtoF(day.temperatureMax)}
                  <span className="type-minisymbol">°F</span>
                </div>
                <div className="weather-7day-low type-xl">
                  {CtoF(day.temperatureMin)}
                  <span className="type-minisymbol">°F</span>
                </div>
              </li>
            );
          })}
      </ul>
    </section>
  );
};

export default SevenDay;
